import PeriodValueFormulaNode from "./PeriodValueFormulaNode.js";

/**
 * `yearOpeningBalanceFormulaNode` is a concrete implementation of `periodValueFormulaNode`
 * representing an opening balance node for the year.
 */

/**
 * TODO: write documentation
 */
export default class YearOpeningBalanceFormulaNode extends PeriodValueFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitYearOpeningBalanceNode(this, additionalInformation);
	}

	static getType() {
		return "YearOpeningBalanceNode";
	}

	static build(builder, additionalInformation) {
		return builder.buildPeriodValueNode(this, additionalInformation);
	}
}
